'use client'

import { Modal } from '@wiggui/ds/Modal'
import { useModalBrokerInvitation } from './useModalBrokerInvitation'
import { Pending } from './steps/pending/Pending'
import { Completed } from './steps/completed/Completed'
import { Rejected } from './steps/rejected/Rejected'

export const ModalBrokerInvitation = () => {
  const { status, isOpenModal } = useModalBrokerInvitation()

  return (
    <Modal isOpen={isOpenModal} enableBgBlur className="w-full max-w-[410px]">
      {status === 'PENDING' && <Pending />}
      {status === 'ACCEPTED' && <Completed />}
      {status === 'REJECTED' && <Rejected />}
    </Modal>
  )
}
